export default __webpack_public_path__ + "static/media/Check.c07ad2d3.svg";